export const API = 'https://shortcodeafrica.com';
